<kt-base-modal [title]="'End Break'">
  <div modal-body>
    <div class="row">
      <div class="col-12">
        <div class="h5 text-center bg-light p-3 mb-3">
          Distance From Actual Location {{distanceFromActualLocation | number : '1.2-2'}} KMs
        </div>
      </div>
      <div class="col-xl-6 form-group">
        <google-map *ngIf="mapReady() && location().latitude" class="kt-map d-block w-100" width="100%" height="400px"
          [center]="{ lat: location().latitude, lng: location().longitude }" [zoom]="18" [options]="{ streetViewControl: false }">
          <map-marker #m1="mapMarker" [position]="{ lat: location().latitude, lng: location().longitude }"
            [options]="{ draggable: false, icon: defaultEnum.LOCATION_ICON_URL, title: 'My Current Location' }"
            (mapClick)="openInfoWindow(m1, 'My Current Location')">
          </map-marker>
          <map-marker #m2="mapMarker" *ngIf="shiftDetails"
            [position]="{ lat: (+shiftDetails.area.area_latitude), lng: (+shiftDetails.area.area_longitude) }"
            [options]="{ draggable: false }"
            (mapClick)="openInfoWindow(m2, (shiftDetails?.area?.area_name || '') + ' ' + (shiftDetails?.area?.area_address || ''))">
          </map-marker>
          <map-info-window>{{ infoContent }}</map-info-window>
        </google-map>
      </div>
      <div class="col-xl-6">
        <div class="form-group">
          <label>Start Time</label>
          <div class="form-control">{{ startTime }}</div>
        </div>
        <div class="form-group">
          <label>End Time</label>
          <div class="form-control">{{currentTime}}</div>
        </div>
        <div class="h5">
          Total Duration: {{breakDuration}} 
        </div>
      </div>
    </div>



    <!-- Distance -->
    <!-- <div class="h5 text-center bg-light p-3 my-3">
      Distance From Actual Location {{distanceFromActualLocation | number : '1.2-2'}} KMs
    </div> -->

    <!-- Duration details -->
    <!-- <div class="h5 text-center bg-light p-3 my-3">
        <div>Start Time: {{startTime}}</div>
        <div>End Time: {{getCurrentTime()}}</div>
        <div>TotalDuration: {{getBreakDuration()}} Minutes</div>
    </div> -->


    <!-- footer start -->
    <div class="modal-footer justify-content-between">
      <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
      </kt-button>
      <kt-button [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG" (buttonClick)="endBreakHandler()">
      </kt-button>
    </div>
    <!-- footer end -->

  </div>
</kt-base-modal>